import React from "react";
import { GlobalOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import trans from "../../../utils";

export default function OfflineHeader({ title, subTitle, btn, online }) {
	const navigate = useNavigate();

	return (
		<div className="offline-header">
			<div>
				<div
					style={{
						fontWeight: "600",
						fontSize: "20px",
						color: "#000000E0",
						lineHeight: "28px",
					}}
				>
					{title}
				</div>
				<div
					style={{
						fontWeight: "400",
						fontSize: "14px",
						color: "#647188",
						lineHeight: "22px",
					}}
				>
					{subTitle}
				</div>
			</div>
			<div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
				{online && (
					<div
						onClick={() => navigate("/setup/offline-setup")}
						style={{
							display: "flex",
							alignItems: "center",
							gap: "6px",
							padding: "6px 14px",
							background: "#f0f5ff",
							color: "#1890ff",
							border: "1px solid #91d5ff",
							borderRadius: "6px",
							fontSize: "13px",
							fontWeight: "500",
							cursor: "pointer",
							transition: "all 0.2s ease",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = "#e6f7ff";
							e.currentTarget.style.borderColor = "#69c0ff";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = "#f0f5ff";
							e.currentTarget.style.borderColor = "#91d5ff";
						}}
					>
						<GlobalOutlined style={{ fontSize: "14px" }} />
						<span>{trans("Return to Online")}</span>
					</div>
				)}

				{btn}
			</div>
		</div>
	);
}
